var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable, Injector } from "@angular/core";
import { MathUtils } from "../utility/math-utils";
import { OrderManager } from "./order-manager";
import { MenuManager } from "./menu-manager";
/**
 * This discount manager is used to
 * calculate all discounts applied for current order
 * @function applyPromotion: apply all discounts orderly by priority,
 *           and calculate the order grand total
 * @function apply: apply one discount, check if all conditions are satisfied
 *           and then apply discount via main condition
 * **/
var DiscountManager = /** @class */ (function () {
    function DiscountManager(injector) {
        this.orderManager = injector.get(OrderManager);
        this.menuManager = injector.get(MenuManager);
    }
    /**apply discount, by priority (sorted on server)
     *can apply multiple discounts
     * **/
    DiscountManager.prototype.applyPromotions = function (order, promotions) {
        order.discount = 0;
        order.discounts = [];
        var applied = 0;
        //for duplicated promos (cdc coupon) fix itemgroup_count, can support mainitem only
        //reset applied for all mainitems/ a le carte
        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            var group = oi.groups[0];
            oi['tmpApplied'] = 0;
            oi['discountClaimed'] = 0;
            oi.discounts = [];
            oi.discount = 0;
        }
        order.promotions = this.sortDiscountPrioInDescending(promotions);
        for (var _b = 0, promotions_1 = promotions; _b < promotions_1.length; _b++) {
            var promo = promotions_1[_b];
            if (applied && promo.alone) {
                //reset the condition applicable
                for (var _c = 0, _d = promo.conditions; _c < _d.length; _c++) {
                    var c = _d[_c];
                    c.applicable = 0;
                }
                continue;
            }
            var success = this.apply(order, promo);
            this.orderManager.calcDiscountGrandTotal(order);
            if (success && promo.benefits[0] && promo.benefits[0].isDiscount()) {
                if (promo.alone)
                    applied++;
                console.log("applied ", promo.name);
            }
        }
        // in case calculate new tax
        this.orderManager.calcDiscountGrandTotal(order);
    };
    DiscountManager.prototype.sortDiscountPrioInDescending = function (promos) {
        promos = promos.sort(function (a, b) { return (b.priority - a.priority); });
        return promos;
    };
    DiscountManager.prototype.sortOrderItemInAscendingOrder = function (order) {
        if (order && order.orderitems) {
            order.orderitems = order.orderitems.sort(function (a, b) { return (a.total - b.total); });
        }
    };
    /**
     * Apply one single discount
     * check all conditions
     * take main condition to apply discount
     * **/
    DiscountManager.prototype.checkPromotionConditionCanApply = function (order, promo) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        var now = this.menuManager.getTime(this.orderManager.store);
        if (promo && promo.periods && promo.periods.length > 0) {
            if (!this.menuManager.isAvailabeByPeriods(this.orderManager.store, promo.periods, now))
                return false;
        }
        if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !promo.enabled)
            return false;
        var ok = true;
        conditions.forEach(function (c) {
            if (ok && !c.isSatisfied(order, promo))
                ok = false;
        });
        return ok;
    };
    DiscountManager.prototype.apply = function (order, promo) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        console.log("applying discount...");
        console.log("conditions:", conditions);
        console.log("benefits:", benefits);
        console.log("order", order);
        console.log("discount", promo);
        var now = this.menuManager.getTime(this.orderManager.store);
        if (promo && promo.periods && promo.periods.length > 0) {
            if (!this.menuManager.isAvailabeByPeriods(this.orderManager.store, promo.periods, now)) {
                //reset applicable
                promo.conditions.forEach(function (con) {
                    con.applicable = 0;
                });
                return false;
            }
        }
        if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !promo.enabled)
            return false;
        var ok = true;
        conditions.forEach(function (c) {
            if (ok && !c.isSatisfied(order, promo))
                ok = false;
        });
        if (ok) { // all conditions are satisfied
            var c = this.getMainCondition(conditions);
            var b = promo.benefits[0];
            var amount = c.apply(order, promo, b, this.orderManager.store, this.orderManager);
            console.log("condition ok ", c.display);
            console.log("applying discount amount: ", amount);
            promo.level = c.level;
            if (amount > 0) { //calculable discount
                amount = MathUtils.round(amount, 2);
                promo.amount = amount;
                promo.quantity = 1;
                order.discounts.push(promo);
                var totalDeduct = amount;
                console.log("Total deduct: ", totalDeduct);
                var grandTotal = order.grandTotal - totalDeduct;
                var discount = order.discount + totalDeduct;
                order.grandTotal = grandTotal;
                var p = this.getStoreGrandTotalPrecision(this.orderManager.store.currency);
                order.discount = MathUtils.round(discount, p);
            }
            else if (b.applied) { //unlock a new discount, or gift discount (not calculable)
            }
            else {
                console.log("skipping-", promo.name, ": conditions satisfied, benefit not applicable");
                ok = false; //if apply at least one discount
            }
        }
        else {
            promo.available = 0;
        }
        return ok;
    };
    DiscountManager.prototype.getStoreGrandTotalPrecision = function (currency) {
        if (!currency)
            return 1;
        var c = currency.slice(0, 2);
        if ("HK" === c) {
            return 1;
        }
        else if ("SG" === c) {
            return 2;
        }
        else if ("MY" === c) {
            //return "MYR";
        }
        else if ("CN" === c) {
            return 1;
        }
        else if ("TW" === c) {
            //return "TWD";
        }
        else if ("MO" === c) {
            //return "MOP";
        }
        else if ("US" === c) {
            return 2;
        }
        else if ("CA" === c) {
            return 2;
        }
        else if ("IN" === c) {
            //return "INR";
        }
        else if ("VN" === c) {
            //return "VND";
        }
        else if ("AU" === c) {
            return 2;
        }
        else if ("NZ" === c) {
            //return "NZD";
        }
        else if ("KR" === c) {
            //return "KRW";
        }
        else if ("ID" === c) {
            //return "IDR";
        }
        else if ("TH" === c) {
            //return "THB";
        }
        return 1;
    };
    /**
     * Get main condition for a discount
     * when there is a condition is of item level, the first item level condition is the main condition,
     * otherwise, the first condition is the main condition
     * **/
    DiscountManager.prototype.getMainCondition = function (conds) {
        var mainCond;
        conds.forEach(function (c) {
            if (!mainCond)
                if (c.level == "item")
                    mainCond = c;
        });
        if (!mainCond)
            mainCond = conds[0];
        return mainCond;
    };
    DiscountManager.prototype.applyCourtPromotions = function (order, promotions) {
        order.discount = 0;
        order.discounts = [];
        var applied = 0;
        //for duplicated promos (cdc coupon) fix itemgroup_count, can support mainitem only
        //reset applied for all mainitems/ a le carte
        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            var group = oi.groups[0];
            oi['tmpApplied'] = 0;
            oi['discountClaimed'] = 0;
            oi.discounts = [];
            oi.discount = 0;
        }
        order.promotions = this.sortDiscountPrioInDescending(promotions);
        for (var _b = 0, promotions_2 = promotions; _b < promotions_2.length; _b++) {
            var promo = promotions_2[_b];
            if (applied && promo.alone) {
                //reset the condition applicable
                for (var _c = 0, _d = promo.conditions; _c < _d.length; _c++) {
                    var c = _d[_c];
                    c.applicable = 0;
                }
                continue;
            }
            var success = this.applyCourt(order, promo);
            // this.orderManager.calcDiscountGrandTotal(order);
            if (success && promo.benefits[0] && promo.benefits[0].isDiscount()) {
                if (promo.alone)
                    applied++;
                console.log("applied ", promo.name);
            }
        }
        // in case calculate new tax
        // this.orderManager.calcDiscountGrandTotal(order);
    };
    DiscountManager.prototype.applyCourt = function (order, promo) {
        var conditions = promo.conditions;
        var benefits = promo.benefits;
        promo.available = 0;
        console.log("applying discount...");
        console.log("conditions:", conditions);
        console.log("benefits:", benefits);
        console.log("order", order);
        console.log("discount", promo);
        var ok = true;
        conditions.forEach(function (c) {
            if (ok && !c.isSatisfied(order, promo))
                ok = false;
        });
        if (ok) { // all conditions are satisfied
            var c = this.getMainCondition(conditions);
            var b = promo.benefits[0];
            var amount = c.apply(order, promo, b);
            console.log("condition ok ", c.display);
            console.log("applying discount amount: ", amount);
            promo.level = c.level;
            if (amount > 0) { //calculable discount
                amount = MathUtils.round(amount, 2);
                promo.amount = amount;
                promo.quantity = 1;
                order.discounts.push(promo);
                var totalDeduct = amount;
                console.log("Total deduct: ", totalDeduct);
                var grandTotal = order.grandTotal - totalDeduct;
                var discount = order.discount + totalDeduct;
                order.grandTotal = grandTotal;
                // let p = this.getStoreGrandTotalPrecision(this.orderManager.store.currency);
                order.discount = MathUtils.round(discount, 1);
            }
            else if (b.applied) { //unlock a new discount, or gift discount (not calculable)
            }
            else {
                console.log("skipping-", promo.name, ": conditions satisfied, benefit not applicable");
                ok = false; //if apply at least one discount
            }
        }
        else {
            promo.available = 0;
        }
        return ok;
    };
    DiscountManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Injector])
    ], DiscountManager);
    return DiscountManager;
}());
export { DiscountManager };
//# sourceMappingURL=discount-manager.js.map